/* eslint-disable max-len */
import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import SettingsScreen from '../SettingsScreen';
import NotificationsSettingRoutes from '../screens/Communications/routes/NotificationsSettingRoutes';
import WebhookEditScreen from '../screens/Connections/screens/WebhookEditScreen/WebhookEditScreen';
import WebhooksScreen from '../screens/Connections/screens/WebhooksScreen/WebhooksScreen';
import LanguageCountryCurrency from '../screens/General/LanguageCountryCurrency/LanguageCountryCurrency';
import UpdateOrCreateCountry from '../screens/General/LanguageCountryCurrency/screens/UpdateOrCreateCounry/UpdateOrCreateCountry';
import UpdateOrCreateCurrency from '../screens/General/LanguageCountryCurrency/screens/UpdateOrCreateCurrency/UpdateOrCreateCurrency';
import UpdateOrCreateLanguageTranslation from '../screens/General/LanguageCountryCurrency/screens/UpdateOrCreateLanguageTranslation/UpdateOrCreateLanguageTranslation';
import ManageUsers from '../screens/General/ManageUsers/ManageUsers';
import EditUser from '../screens/General/ManageUsers/screens/EditUser/EditUser';
import ConsumerChannelsConfigScreen from '../screens/OrderingChannel/screens/ConsumerChannelsConfigScreen/ConsumerChannelsConfigScreen';
import FranchiseManagement from '../screens/Orders/screens/FranchiseManagement/FranchiseManagement';
import OrderConfiguration from '../screens/Orders/screens/OrderConfiguration/OrderConfiguration';
import PreparationProfilesSettingsScreen from '../screens/Orders/screens/PreparationProfilesSettingsScreen/PreparationSettingsProfiles';
import WebsiteInfoScreen from '~/view/screens/SettingsScreen/screens/OrderingChannel/screens/WebsiteInfoScreen/WebsiteInfoScreen';
import EditFAQScreen from '~/view/screens/SettingsScreen/screens/OrderingChannel/screens/EditFAQScreen/EditFAQScreen';
import IntegrationsListScreen from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/screens/IntegrationsListScreen/IntegrationsListScreen';
import IntegrationScreen from '~/view/screens/SettingsScreen/screens/Integrations/Integrations/screens/IntegrationScreen/IntegrationScreen';
import KiosksScreen from '~/view/screens/SettingsScreen/screens/Devices/screens/KiosksScreen/KiosksScreen';
import KioskEditScreen from '~/view/screens/SettingsScreen/screens/Devices/screens/KioskEditScreen/KioskEditScreen';
import { appStore } from '~/mobx/appStore';
import CustomRoute from 'src/view/components/CustomRoute/CustomRoute';
import { SCREENS } from 'src/constants/screens';

const SettingsRoutes: FC = (): JSX.Element => {
  return (
    <Switch>
      <Route path={SCREENS.SETTINGS()} component={SettingsScreen} exact />
      {/* General */}
      <CustomRoute path={[SCREENS.SETTINGS_USERS(), SCREENS.SETTINGS_USER_ROLES()]} component={ManageUsers} exact />
      <CustomRoute path={[SCREENS.SETTINGS_USERS_EDIT(':id')]} component={EditUser} exact />
      <CustomRoute path={[SCREENS.SETTINGS_USERS_CREATE()]} component={EditUser} exact />
      <CustomRoute
        path={[SCREENS.SETTINGS_COUNTRIES(), SCREENS.SETTINGS_CURRENCY(), SCREENS.SETTINGS_TRANSLATION()]}
        component={LanguageCountryCurrency}
        exact
      />
      <CustomRoute path={[SCREENS.SETTINGS_COUNTRY_EDIT(':id')]} component={UpdateOrCreateCountry} exact />
      <CustomRoute path={[SCREENS.SETTINGS_COUNTRY_CREATE()]} component={UpdateOrCreateCountry} exact />
      <CustomRoute path={[SCREENS.SETTINGS_CURRENCY_EDIT(':id')]} component={UpdateOrCreateCurrency} exact />
      <CustomRoute path={[SCREENS.SETTINGS_CURRENCY_CREATE()]} component={UpdateOrCreateCurrency} exact />
      <CustomRoute path={[SCREENS.SETTINGS_TRANSLATION_EDIT(':id')]} component={UpdateOrCreateLanguageTranslation} exact />
      <CustomRoute path={[SCREENS.SETTINGS_TRANSLATION_CREATE()]} component={UpdateOrCreateLanguageTranslation} exact />

      {/* Ordering channels */}
      <CustomRoute path={SCREENS.SETTINGS_CONSUMER_CHANNELS_CONFIG()} component={ConsumerChannelsConfigScreen} />
      <CustomRoute
        path={[
          SCREENS.SETTINGS_WEBSITE_ABOUT(),
          SCREENS.SETTINGS_WEBSITE_TERMS_CONDITIONS(),
          SCREENS.SETTINGS_WEBSITE_PRIVACY_POLICY(),
          SCREENS.SETTINGS_WEBSITE_CONTACT_US(),
          SCREENS.SETTINGS_WEBSITE_MANAGE_FAQ(),
          SCREENS.SETTINGS_WEBSITE_COOKIES(),
          SCREENS.SETTINGS_WEBSITE_FRANCHISE(),
        ]}
        component={WebsiteInfoScreen}
        exact
      />
      <CustomRoute path={[SCREENS.SETTINGS_WEBSITE_MANAGE_FAQ_EDIT(':id')]} component={EditFAQScreen} exact />
      <CustomRoute path={[SCREENS.SETTINGS_WEBSITE_MANAGE_FAQ_CREATE()]} component={EditFAQScreen} exact />

      {/* Orders */}
      <Route path={SCREENS.SETTINGS_ORDERS()} exact>
        <Redirect to={SCREENS.SETTINGS_ORDERS_CONDITIONS()} />
      </Route>
      <CustomRoute
        path={[SCREENS.SETTINGS_ORDERS_CONDITIONS()]}
        access={!appStore.isAddonsAvailable.franchise}
        redirectPath={SCREENS.SETTINGS_ORDERS_NOTES()}
        component={OrderConfiguration}
      />
      <CustomRoute path={[SCREENS.SETTINGS_ORDERS_NOTES()]} component={OrderConfiguration} />
      <CustomRoute path={SCREENS.SETTINGS_PREPARATION_PROFILES()} component={PreparationProfilesSettingsScreen} exact />
      <CustomRoute path={[SCREENS.SETTINGS_ORDERS_FRANCHISE()]} access={appStore.isAddonsAvailable.franchise} component={FranchiseManagement} />

      {/* Connections */}
      <CustomRoute exact path={SCREENS.SETTINGS_WEBHOOK()} component={WebhooksScreen} access={appStore.isAddonsAvailable.webhook} />
      <CustomRoute
        exact
        path={[SCREENS.SETTINGS_WEBHOOK_EDIT(':id'), SCREENS.SETTINGS_WEBHOOK_CREATE()]}
        component={WebhookEditScreen}
        access={appStore.isAddonsAvailable.webhook}
      />

      {/* Communication */}
      <CustomRoute path={SCREENS.SETTINGS_NOTIFICATIONS()} component={NotificationsSettingRoutes} />

      {/* Devices */}
      <CustomRoute exact path={[SCREENS.SETTINGS_DEVICES_KIOSKS()]} component={KiosksScreen} access={appStore.isAddonsAvailable.kiosk} />
      <CustomRoute
        path={[SCREENS.SETTINGS_DEVICES_KIOSKS_CREATE(), SCREENS.SETTINGS_DEVICES_KIOSKS_EDIT(':id')]}
        component={KioskEditScreen}
        access={appStore.isAddonsAvailable.kiosk}
      />

      {/* Integrations */}
      <CustomRoute path={SCREENS.SETTINGS_INTEGRATIONS()} component={IntegrationsListScreen} exact />
      <CustomRoute path={SCREENS.SETTINGS_INTEGRATION(':id')} component={IntegrationScreen} exact />
    </Switch>
  );
};

export default SettingsRoutes;
